import { render, staticRenderFns } from "./AllocatedMismatch.vue?vue&type=template&id=5331db5a"
import script from "./AllocatedMismatch.vue?vue&type=script&lang=js"
export * from "./AllocatedMismatch.vue?vue&type=script&lang=js"
import style0 from "./AllocatedMismatch.vue?vue&type=style&index=0&id=5331db5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports